var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavMenuShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.36364 13.9999C1.0303 13.9999 0 12.9696 0 11.6363V2.42418C0 1.09085 1.0303 0.0605469 2.36364 0.0605469H8.60606C9.09091 0.0605469 9.39394 0.363577 9.39394 0.78782C9.39394 1.21206 9.0303 1.5757 8.60606 1.5757H2.36364C1.87879 1.5757 1.51515 1.93933 1.51515 2.42418V11.6969C1.51515 12.1818 1.87879 12.5454 2.36364 12.5454H11.5758C12.0606 12.5454 12.4242 12.1818 12.4242 11.6969V6.90903C12.4242 6.48479 12.7879 6.12115 13.2121 6.12115C13.6364 6.12115 14 6.42418 14 6.84843V11.6363C14 12.303 13.7576 12.909 13.3333 13.3333C12.9091 13.7575 12.303 13.9999 11.6364 13.9999H2.36364Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81815 11.3939C5.39391 11.3939 5.03027 11.0303 5.03027 10.6061V9.81818C5.03027 6 8.12118 2.90909 11.9394 2.90909H13.3939L11.5757 1.33333C11.4545 1.21212 11.3333 0.969697 11.3333 0.787879C11.3333 0.545455 11.3939 0.363636 11.5151 0.242424C11.6969 0.060606 11.8788 0 12.0606 0C12.303 0 12.4848 0.060606 12.606 0.181818L15.8788 3.0303C16.0606 3.21212 16.1212 3.39394 16.1212 3.57576C16.1818 3.81818 16.1212 4 16 4.06061C15.8788 4.18182 15.8182 4.24242 15.7575 4.24242C15.5757 4.36364 15.4545 4.42424 15.2727 4.42424H12C9.03027 4.42424 6.60603 6.84848 6.60603 9.81818V10.6061C6.60603 11.0303 6.303 11.3939 5.81815 11.3939Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavMenuShare);
export default __webpack_public_path__ + "static/media/nav_menu_share.d882e772643df75a57e3d4c251d45281.svg";
export { ForwardRef as ReactComponent };